
  import * as ipxRuntime$bQZvekG7VypoSRjh2zLG23rJXu5WWtFqlvIevcGJ3rQ from '/app/node_modules/.pnpm/@nuxt+image@1.11.0_db0@0.3.4_better-sqlite3@12.4.1__ioredis@5.8.0_magicast@0.3.5/node_modules/@nuxt/image/dist/runtime/providers/ipx'
import * as ipxRuntime$JnEoP5ZmNEi7029o1RfQNhHRXNqzsjkpBDAn6SmZ5Gs from '/app/app/image-provider.ts'
  
  export const imageOptions = {
    ...{
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
},
    providers: {
        ['ipx']: { provider: ipxRuntime$bQZvekG7VypoSRjh2zLG23rJXu5WWtFqlvIevcGJ3rQ, defaults: {"maxAge":31536000} },
  ['ipx']: { provider: ipxRuntime$JnEoP5ZmNEi7029o1RfQNhHRXNqzsjkpBDAn6SmZ5Gs, defaults: undefined }
    }
  }
